import { SchedulingAction as SchedulingActionApi } from '@wix/ambassador-nownia-action-v1-enriched-action/types';
import { ActionType } from '../Action';
import { isValidEnrichedAction, SchedulingAction } from './EnrichedAction';
const schedulingActionApiToSchedulingAction = {
  [SchedulingActionApi.UNKNOWN]: SchedulingAction.UNKNOWN,
  [SchedulingActionApi.SCHEDULE]: SchedulingAction.SCHEDULE,
  [SchedulingActionApi.RESCHEDULE]: SchedulingAction.RESCHEDULE,
  [SchedulingActionApi.CANCEL]: SchedulingAction.CANCEL
};
const schedulingActionToSchedulingActionApi = {
  [SchedulingAction.UNKNOWN]: SchedulingActionApi.UNKNOWN,
  [SchedulingAction.SCHEDULE]: SchedulingActionApi.SCHEDULE,
  [SchedulingAction.RESCHEDULE]: SchedulingActionApi.RESCHEDULE,
  [SchedulingAction.CANCEL]: SchedulingActionApi.CANCEL
};
const actionTypeToSchedulingAction = {
  [ActionType.SCHEDULE_MEETING]: SchedulingAction.SCHEDULE,
  [ActionType.EDIT_MEETING]: SchedulingAction.RESCHEDULE,
  [ActionType.CANCEL_MEETING]: SchedulingAction.CANCEL,
  [ActionType.CREATE_RECURRING_SCHEDULE]: SchedulingAction.SCHEDULE,
  [ActionType.EDIT_RECURRING_SCHEDULE]: SchedulingAction.RESCHEDULE,
  [ActionType.CANCEL_RECURRING_SCHEDULE]: SchedulingAction.CANCEL,
  [ActionType.ANNOUNCEMENT]: SchedulingAction.SCHEDULE,
  [ActionType.UNKNOWN]: SchedulingAction.UNKNOWN
};
export const convertSchedulingActionApiToSchedulingAction = schedulingAction => {
  const convertedAction = schedulingActionApiToSchedulingAction[schedulingAction];
  if (!convertedAction) {
    throw new Error(`Unknown SchedulingActionApi: ${schedulingAction}`);
  }
  return convertedAction;
};
export const convertActionTypeToSchedulingAction = type => {
  const convertedAction = actionTypeToSchedulingAction[type];
  if (!convertedAction) {
    throw new Error(`Unknown ActionType: ${type}`);
  }
  return convertedAction;
};
export const enrichedActionToEnrichedActionApi = enrichedAction => {
  return {
    id: enrichedAction.id,
    revision: enrichedAction.revision,
    schedulingAction: schedulingActionToSchedulingActionApi[enrichedAction.schedulingAction],
    participants: enrichedAction.participants // TODO: change after package is updated
  };
};
export const enrichedActionApiToEnrichedActionEntity = enrichedActionApi => {
  if (!enrichedActionApi) {
    throw new Error('Invalid enrichedActionApi', {
      cause: {
        enrichedActionApi
      }
    });
  }
  const convertedEnrichedAction = {
    id: enrichedActionApi.id,
    revision: enrichedActionApi.revision,
    schedulingAction: convertSchedulingActionApiToSchedulingAction(enrichedActionApi.schedulingAction),
    participants: enrichedActionApi.participants,
    // TODO: change after package is updated
    taskDescription: enrichedActionApi.taskDescription
  };
  if (isValidEnrichedAction(convertedEnrichedAction)) {
    return convertedEnrichedAction;
  }
  throw new Error('Invalid enrichedAction data', {
    cause: {
      convertedEnrichedAction
    }
  });
};
//# sourceMappingURL=converters.js.map